import { Box, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  borderRadius: string;
  borderStyle: string;
  dataAction: string;
}

const ViewSwitchButton = ({ isActive, onClick, icon, borderRadius, borderStyle, dataAction }: IProps) => {
  const { palette } = useTheme();
  return (
    <Box
      onClick={onClick}
      sx={{
        transition: 'all 0.3s',
        borderRadius,
        borderStyle,
        padding: '6px',
        backgroundColor: isActive ? palette.action.selected : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      data-action={dataAction}
    >
      {icon}
    </Box>
  );
};

export default ViewSwitchButton;
